import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setDefaultLanguage, setLanguage, setLanguageCookie, setTranslations } from "react-switch-lang";
import { RootState } from "../../store";
import { languageActions } from "../../store/redux/languageSlice";
import styles from "./translate.module.scss";
// import en from "../../assets/i18n/en.json";
// import fr from "../../assets/i18n/fr.json";
// import ts from "../../assets/i18n/test.json";
//french json translate
import accueil from "../../assets/i18n/fr/accueil.json";
import biblio from "../../assets/i18n/fr/biblio.json";
import category from "../../assets/i18n/fr/category.json";
import commun from "../../assets/i18n/fr/commun.json";
import expo from "../../assets/i18n/fr/expo.json";
import footer from "../../assets/i18n/fr/footer.json";
import header from "../../assets/i18n/fr/header.json";
import param from "../../assets/i18n/fr/param.json";
import thematicFolder from "../../assets/i18n/fr/thematic-folder.json";
import video from "../../assets/i18n/fr/video.json";
import statistic from "../../assets/i18n/fr/statistic.json";
//English json translate
import home from "../../assets/i18n/en/accueil.json";
import library from "../../assets/i18n/en/biblio.json";
import categoryEn from "../../assets/i18n/en/category.json";
import communEn from "../../assets/i18n/en/commun.json";
import expoEn from "../../assets/i18n/en/expo.json";
import footerEn from "../../assets/i18n/en/footer.json";
import headerEn from "../../assets/i18n/en/header.json";
import paramEn from "../../assets/i18n/en/param.json";
import thematicFolderEn from "../../assets/i18n/en/thematic-folder.json";
import videoEn from "../../assets/i18n/en/video.json";
import statisticEn from "../../assets/i18n/en/statistic.json";
import Cookies from "js-cookie";

setTranslations({
  en: { ...home, ...library, ...categoryEn, ...communEn, ...expoEn, ...footerEn, ...headerEn, ...paramEn, ...thematicFolderEn, ...videoEn, ...statisticEn },
  fr: { ...accueil, ...biblio, ...category, ...commun, ...expo, ...footer, ...header, ...param, ...thematicFolder, ...video, ...statistic },
});
setDefaultLanguage(Cookies.get("language") || "fr");
setLanguageCookie();

const Translate: React.FC = () => {
  const [selected, setSelected] = useState(useSelector((state: RootState) => state.language.currentLang));
  const dispath = useDispatch();

  const handleSetLanguage = key => {
    setLanguage(key);
    setSelected(key);
    dispath(languageActions.updateCurrentLang(key));
  };

  return (
    <div className={styles["translate-wrapper"]}>
      <div className={styles["icon-lang"] + " lang"} onClick={() => handleSetLanguage("fr")}>
        <i className={`${styles["translate-icon"]} flag-icon flag-icon-fr ${selected === "fr" ? styles["active"] : ""}`}></i>
      </div>
      <div className={styles["icon-lang"] + " lang"} onClick={() => handleSetLanguage("en")}>
        <i className={`${styles["translate-icon"]} flag-icon flag-icon-gb ${selected === "en" ? styles["active"] : ""} `}></i>
      </div>
    </div>
  );
};
export default Translate;
